var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Schema, type } from "@colyseus/schema";
/**
 * One point in the match the creator may roll the board back to — the synced
 * INDEX of the restore ring, not the board data itself. The full snapshot
 * behind each entry lives server-side (gzipped in memory, mirrored to the
 * `game_snapshots` collection so it survives a restart); this list only tells
 * the client which moments are offerable and how to label them.
 *
 * Captured at turn and round boundaries, kept for the last
 * `RESTORE_WINDOW_TURNS` turns, and pruned FORWARD by a restore — the points
 * after the one used describe a future that no longer happened.
 *
 * Deliberately NOT persisted in the game state document: it is rebuilt on
 * resume from the snapshot collection's index, so the ring and its blobs can
 * never disagree about what exists.
 */
export class RestorePoint extends Schema {
    constructor() {
        super(...arguments);
        /** Monotonic server id — the handle a restore command names. Never reused,
         * including across a restore (which only ever discards ids). */
        this.id = 0;
        /** Round in progress at (for a "round" point, beginning at) this moment. */
        this.round = 0;
        /** Global turn counter at this moment. A "round" point carries the turn
         * number it interrupted — the round's first turn hasn't started yet. */
        this.turn = 0;
        /** "turn" | "round" — see `RestoreKind`. */
        this.kind = "turn";
        /** Display name of the player whose turn begins here ("" for a round
         * point), snapshotted so the label survives them leaving. */
        this.playerName = "";
        /** That player's seat, for the label's seat colour. */
        this.seat = 0;
        /** `historySeq` at capture: every move-history entry with a HIGHER id
         * happened after this moment. Drives both where the client draws the
         * point in the Turn History list and what a restore trims the history to.
         */
        this.afterHistoryId = 0;
    }
}
__decorate([
    type("uint32")
], RestorePoint.prototype, "id", void 0);
__decorate([
    type("uint16")
], RestorePoint.prototype, "round", void 0);
__decorate([
    type("uint16")
], RestorePoint.prototype, "turn", void 0);
__decorate([
    type("string")
], RestorePoint.prototype, "kind", void 0);
__decorate([
    type("string")
], RestorePoint.prototype, "playerName", void 0);
__decorate([
    type("uint8")
], RestorePoint.prototype, "seat", void 0);
__decorate([
    type("uint32")
], RestorePoint.prototype, "afterHistoryId", void 0);
//# sourceMappingURL=RestorePoint.js.map